import { useState } from "react";
import { useContext, useEffect } from "react";
/*import { FormGroup, Input, Label, Row, Col, Button } from "reactstrap";*/
import { UserContext } from "../context/UserProvider";
import { Api } from '../componentes/Api';
import emailjs from '@emailjs/browser';
import React, { useRef } from 'react';
import { Card, CardBody, Row, Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"

import Swal from 'sweetalert2';

const modelo = {
    nombre: "",
    correo: "",
    idRolNavigation: {
        descripcion :""
    }
}
let modelo1 = {
    ClaveA: "",
    ClaveN: ""
}

const Inicio = () => {

    const { user } = useContext(UserContext)
    const [ dataUser, setDataUser ] = useState(modelo)
    const [dataClave, setDataClave] = useState(modelo1)
    const [verModal, setVerModal] = useState(false);
    const [imageSrc, setImageSrc] = useState("");
    const [file, setFile] = useState(null);
    const [CambiarFoto, setCambiarFoto] = useState(false);
     
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleUpload = async () => {
        if (!file) return;

        const formData = new FormData();
        formData.append("image", file);

        const response = await fetch(Api + "Usuario/UploadImage/"  + dataUser.idUsuario, {
            method: "POST",
            body: formData,
        });

        const data = await response.json();
        fetchImage1();
        setCambiarFoto(false)
        setFile(null)
        console.log("Respuesta:", data);
    };
    const fetchImage1 = async () => {
        const response = await fetch(Api + "Usuario/MostraFoto/" + dataUser.idUsuario);
        const blob = await response.blob();
        setImageSrc(URL.createObjectURL(blob));
    };

    useEffect(() => {
        const fetchImage = async () => {
            const response = await fetch(Api + "Usuario/MostraFoto/" + dataUser.idUsuario);
            if (response.status != 200) {
                setImageSrc("./imagen/Foto003.jpg")
            } else { const blob = await response.blob();
            setImageSrc(URL.createObjectURL(blob)); }
           
        };

        fetchImage();
    }, [dataUser.idUsuario]);



    const Clave = (e) => {
        setDataClave({
            ...dataClave,
            [e.target.name]: e.target.value
        })
    }
    const guardarCambios = async () => {
        if (dataClave.ClaveA == dataClave.ClaveN) {
            Swal.fire(
                'La contraseña nueva no puede ser igual a la anterior!',
                '',
                'error'
            )
        } else {
            let response = await fetch(Api + "Usuario/ModificarContraseña/" + dataUser.idUsuario + "/" + dataClave.ClaveA + "/" + dataClave.ClaveN);

            if (response.ok) {

                setVerModal(false)
                setDataClave(modelo1)
                Swal.fire(
                    'Guardado!',
                    'Una vez vuelva iniciar en el sistema debera poner la clave nueva.',
                    'success'
                )
            } else {
                Swal.fire(
                    'Se produjo un error al intentar cambiar contraseña!',
                    '',
                    'error'
                )
            }
        }
    }
        const [formData, setFormData] = useState({
            name: "",
            email: "",
            message: "",
        });

        const handleChange = (e) => {
            setFormData({ ...formData, [e.target.name]: e.target.value });
        };

        const sendEmail = (e) => {
            e.preventDefault();

            emailjs
                .send(
                    "service_95lb0aa",  // Reemplaza con tu Service ID
                    "template_isxhwwh", // Reemplaza con tu Template ID
                    {
                        to_email: formData.email,
                        from_name: formData.name,
                        message: formData.message,
                    },
                    "Ya-bX4GMQA3dqWVnz" // Reemplaza con tu Public Key
                )
                .then(
                    (response) => {
                        alert("Correo enviado correctamente!");
                    },
                    (error) => {
                        alert("Error al enviar el correo.");
                    }
                );
        };

    const [emailData, setEmailData] = useState({
        to: "",
        subject: "",
        body: ""
    });

    //const handleChange = (e) => {
    //   setEmailData({ ...emailData, [e.target.name]: e.target.value });
    //};

    const sendEmail1 = async () => {
        const emailData1 = {
            to: "info@apatech.com.do",
            subject: "hola mundo",
            body: "Este es el cuerpo del correo."
        };

        try {
            const response = await fetch(Api+"email/send1", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(emailData)
            });

            const data = await response.json();
            alert(data.message);
        } catch (error) {
            alert("Error al enviar el correo");
        }
    };






    useEffect(() => {
        let dt = JSON.parse(user)
        setDataUser(dt)
        if (dt.correo == 'iglesia') {
            window.location.href = '/Amigos'
        }
     
    }, [])

    const SincronizarBajar = async () => {
        let response = await fetch(Api + "Sincronizacion/Sincronizarbajar");
        if (response.ok) {
            let data = await response.json();
        }
    }
      const SincronizarSubir = async () => {
        let response = await fetch(Api + "Sincronizacion/SincronizarSubir");
        if (response.ok) {
            let data = await response.json();
        }
    }
          
    return (
        <>
          
            {(CambiarFoto)? <div >
                <input type="file" onChange={handleFileChange} />
                {(file != null) && <Button color="warning" size="sm" onClick={handleUpload}>Guardar</Button>}
            </div> :""
            }
            <div hidden>
                {imageSrc && <img src={imageSrc} alt="Imagen desde la BD" width="300" />}
            </div>

            <form onSubmit={sendEmail} hidden>
                <input
                    type="text"
                    name="name"
                    placeholder="Tu Nombre"
                    onChange={handleChange}
                    required
                />
                <input
                    type="email"
                    name="email"
                    placeholder="Tu Email"
                    onChange={handleChange}
                    required
                />
                <textarea
                    name="message"
                    placeholder="Tu Mensaje"
                    onChange={handleChange}
                    required
                ></textarea>
                <button type="submit">Enviar</button>
            </form>

            <div hidden>
                <h2>Enviar Correo</h2>
                <input type="email" name="to" placeholder="Correo destinatario" onChange={handleChange} />
                <input type="text" name="subject" placeholder="Asunto" onChange={handleChange} />
                <textarea name="body" placeholder="Mensaje" onChange={handleChange}></textarea>
                <button onClick={sendEmail}>Enviar</button>
            </div>

            <Row>
                <Col sm={12} className="text-left">
                    <h2>Bienvenido al sistema</h2>
                </Col>
            </Row>
            <Row>
                <Col sm={3}>
                    <div className="card">
                        
                       <img className="card-img-top" src={imageSrc} width="300px" alt="Card image cap" /> 
                    </div>
                </Col>
                <Col sm={3}>
                    <FormGroup>
                        <Label>Nombre</Label>
                        <Input disabled value={dataUser.nombre} />
                    </FormGroup>
                    <FormGroup>
                        <Label>Correo</Label>
                        <Input disabled value={dataUser.correo}/>
                    </FormGroup>
                    <FormGroup>
                        <Label>Rol</Label>
                        <Input disabled value={dataUser.idRolNavigation.descripcion}/>
                    </FormGroup>
                    <FormGroup>
                        <Button color="warning" size="sm"
                            onClick={() => setVerModal(!verModal)}
                        >Cambiar Contraseña</Button>
                    </FormGroup>
                    <FormGroup>
                        <Button color="warning" size="sm"
                            onClick={() => setCambiarFoto(!CambiarFoto)}
                        >Cambiar Foto de Perfil</Button>
                    </FormGroup>
                </Col>
                <Col sm={3}>
                </Col>
            </Row>
            <Modal isOpen={verModal} className="">
                <ModalHeader className="modal-header1">
                    Cambiar Contraseña para {dataUser.nombre} codigo empleado {dataUser.empleadoID}
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <FormGroup>
                            <Label>Contraseña anterior</Label>
                            <Input type="password" onChange={Clave} name="ClaveA" />
                        </FormGroup>
                        <FormGroup>
                            <Label>Contraseña Nueva</Label>
                            <Input type="password" onChange={Clave} name="ClaveN" />
                        </FormGroup>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="primary"
                        onClick={guardarCambios}
                    >Guardar</Button>

                    <Button size="sm" color="danger"
                        onClick={() => setVerModal(false)}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

        </>
       
        )
}

export default Inicio;